import { api } from '@dpgradio/creative'
import { defineStore } from 'pinia'

function getOrCreateVoterId() {
  const storageKey = 'live_ratings_voter_id'
  let voterId = localStorage.getItem(storageKey)

  if (!voterId) {
    voterId = crypto.randomUUID()
    localStorage.setItem(storageKey, voterId)
  }

  return voterId
}

export const usePollStore = defineStore('poll', {
  state: () => ({
    ratingId: null,
    hasVoted: false,
    voteValue: null,
    isSubmitting: false,
    error: null,
  }),
  getters: {
    voterId: () => getOrCreateVoterId(),
    canVote: (state) => !state.isSubmitting,
  },
  actions: {
    setRatingId(id) {
      this.ratingId = id
      this.checkIfVoted()
    },

    checkIfVoted() {
      if (!this.ratingId) return

      const storageKey = `live_ratings_${this.ratingId}_voted`
      const voted = localStorage.getItem(storageKey)

      if (voted) {
        this.hasVoted = true
        this.voteValue = Number(voted)
      }
    },

    async submitVote(value) {
      if (!this.canVote) return
      if (!this.ratingId) {
        this.error = 'Geen rating ID beschikbaar.'
        return
      }

      this.isSubmitting = true
      this.error = null

      try {
        await api.request().post(`/live_ratings/${this.ratingId}/votes`, {
          value: value,
          identifier: this.voterId,
        })

        this.hasVoted = true
        this.voteValue = value

        const storageKey = `live_ratings_${this.ratingId}_voted`
        localStorage.setItem(storageKey, String(value))
      } catch (error) {
        this.error = 'Er is iets misgegaan bij het stemmen. Probeer het later nog eens.'
        throw error
      } finally {
        this.isSubmitting = false
      }
    },
  },
})
